import * as ACTIONS from  '../../containers/constants';

export function startNotification(payload) {

  return { type: ACTIONS.CRYODEX_NOTIFICATION_START};
}

export function stopNotification() { 
  return { type: ACTIONS.CRYODEX_NOTIFICATION_STOP };
}